<script>
import Base from './base';

export default {
  extends: Base,
  data() {
    return {
      showCycleAlert: false
    };
  },
  computed: {
    canRmv() {
      return this.$context.type !== this.planType;
    },
  },
};
</script>
